import Vue from 'vue';
import TooltipProvider from '../tooltip/tooltipProvider.component';

export const TooltipProviderMixin = {
  components: { TooltipProvider },
  data() {
    return {
      tooltipEventBus: new Vue(),
    };
  },
  methods: {
    showTooltip(key, data) {
      this.tooltipEventBus.$emit('show-tooltip', { key, data });
    },
    hideTooltip(key) {
      this.tooltipEventBus.$emit('hide-tooltip', { key });
    },
  },
};
